import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'

export const CountrySubdivisionField: React.FC = () => {
  return (
    <Field name="newAddress.countrySubdivision">
      {({ field, meta }: FieldProps) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.countrySubdivision')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
